import React, {useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import {API_PATH} from "../components/const";
import {Modal, Spin} from "antd";

const Login = () => {
    const [userName, setUserName] = useState("")
    const [pass, setPass] = useState("")
    const [companies, setCompanies] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loader, setLoader] = useState(false)
    const [show, setShow] = useState(false)


    let history = useHistory()
    const loginFc = () => {
        let newData = new FormData()
        newData.append('username', userName)
        newData.append('password', pass)
        newData.append('scope', "snapshot:read camera:write camera:read admin:read admin:write line_crossing_analytics:write module:read module:write fleet:read fleet:write config:read config:write line_crossing_analytics:read line_crossing_analytics:write analitiks:read")

        axios.post(API_PATH + "token", newData)
            .then(res => {

                localStorage.setItem("token", res.data?.access_token)
                localStorage.setItem("first_name", res.data?.user_info?.first_name)
                localStorage.setItem("last_name", res.data?.user_info?.last_name)
                localStorage.setItem("username", res.data?.user_info?.username)
                localStorage.setItem("phone_user", res.data?.user_info?.phone)
                localStorage.setItem("image", res.data?.user_info?.image)
                localStorage.setItem("company_type", res?.data?.type)

                if (!res.data?.user_info?.is_superuser) {
                    localStorage.setItem("for_com", res.data?.user_info?.company?.id)
                    axios.get(API_PATH + "company/" + res.data?.user_info?.company?.id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then(res2 => {

                            localStorage.setItem("name", res2?.data?.name)
                            localStorage.setItem("description", res2?.data?.description)
                            localStorage.setItem("phone", res2?.data?.phone)
                            localStorage.setItem("email", res2?.data?.email)
                            localStorage.setItem("id", res2?.data?.id)
                            localStorage.setItem("owner_id", res2?.data?.owner_id)
                            setTimeout(() => {
                                history.push("/main/visitor-home")
                            }, 500)
                        })
                } else {
                    setCompanies(res.data?.user_info?.companies)
                    history.push("global-admin/admin-companies")
                    setIsModalOpen(true)
                }
            })
            .catch(() => {
                toast.error("Неверный логин или пароль, обратитесь к администратору.")
            })
    }
    const selectCompany = (id) => {
        setLoader(true)
        localStorage.setItem("for_com", id)
        axios.get(API_PATH + "company/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res2 => {
                // console.log(localStorage.getItem("token"))
                localStorage.setItem("name", res2?.data?.name)
                localStorage.setItem("description", res2?.data?.description)
                localStorage.setItem("company_type", res2?.data?.type)
                localStorage.setItem("phone", res2?.data?.phone)
                localStorage.setItem("email", res2?.data?.email)
                localStorage.setItem("id", res2?.data?.id)
                localStorage.setItem("owner_id", res2?.data?.owner_id)
                setTimeout(() => {
                    setLoader(false)
                    history.push("/main/visitor-home")
                }, 500)
            })
    }

    let input = document.getElementById("mainLogin");
    let input2 = document.getElementById("mainPassword");
    input?.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
            document.getElementById("loginBtn").click();
        }
    });
    input2?.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
            document.getElementById("loginBtn").click();
        }
    });
    return (
        <div className="main-login">
            <div className="login-top-title">
                <p>Добро пожаловать в <br/> <img className="mt-20" src="/icon/loginlogo.svg" alt="..."/></p>
                <h2></h2>
            </div>
            <div></div>
            <div className="login-box" style={{marginTop: "250px"}}>
                <div className="login-inputs">
                    <h3>Авторизоваться</h3>
                    <div className="inputs-box">
                        <label className="font-family-medium" htmlFor="mainLogin">Login</label>
                        <input type="text" value={userName} id="mainLogin" onChange={(e) => setUserName(e.target.value)}
                               placeholder="Ваш номер телефона или логин"/>
                        <p>Вы можете получить логин в отделе кадров
                            0/0</p>
                    </div>
                    <div className="inputs-box position-relative">
                        <label className="font-family-medium" htmlFor="mainPassword">Пароль </label>
                        <input type={show ? "text" : "password"} value={pass} id="mainPassword" onChange={(e) => setPass(e.target.value)}
                               className="open-hide-pass-padding"
                               placeholder="Ваш пароль"/>
                        <button className="open-hide-pass" onClick={() => setShow(!show)}>
                            {
                                show
                                ?
                                    <img src="/icon/hide.png" alt=""/>
                                    :
                                    <img src="/icon/openeye.png" alt=""/>
                            }
                        </button>
                    </div>
                    <button onClick={loginFc} id="loginBtn" className="login-btn">Вход</button>
                </div>
            </div>
            <div>
            </div>

            <Modal title="Select company"
                   open={isModalOpen}
                   onCancel={() => setIsModalOpen(false)}
                   footer={[]}
            >
                {
                    companies?.map((item, index) => (
                        <div className="company-list">
                            <div className="company-item d-flex align-items-center justify-content-between ">
                                <p>{item?.name}</p>
                                <button onClick={() => selectCompany(item?.id)}>Open</button>
                            </div>
                        </div>
                    ))
                }
            </Modal>
            {
                loader
                    ?

                    <div className="my-loader">
                        <Spin size="large" />
                    </div>
                    :
                    ""
            }
        </div>
    );
};

export default Login;
